import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { LandingPageLP1 } from './pages/LandingPageLP1';
import { LandingPageLP3 } from './pages/LandingPageLP3';
import { LandingPageLP4 } from './pages/LandingPageLP4';
import { LandingPageLP5 } from './pages/LandingPageLP5';
import { LandingPageV2 } from './pages/LandingPageV2';
import { CheckoutPage } from './pages/CheckoutPage';
import { CheckoutPage2 } from './pages/CheckoutPage2';
import { Modulo0Page } from './pages/Modulo0Page';
import { AccessPage } from './pages/AccessPage';
import { Modulo2Page } from './pages/Modulo2Page';
import { Modulo3Page } from './pages/Modulo3Page';
import { Modulo4Page } from './pages/Modulo4Page';
import { SignupPage } from './pages/SignupPage';
import { LoginPage } from './pages/LoginPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { CalculadoraPage } from './pages/CalculadoraPage';
const PIXEL_ID = '1626906698580220';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initFacebookPixel() {
  if (window.fbq) return;
  const f = window;
  const b = document;
  const n = 'script';
  let e: any;
  const t = function (this: any) {
    // eslint-disable-next-line prefer-rest-params
    t.callMethod ? t.callMethod.apply(t, arguments) : t.queue.push(arguments);
  } as any;
  if (!f.fbq) f.fbq = t;
  t.push = t;
  t.loaded = true;
  t.version = '2.0';
  t.queue = [] as any[];
  e = b.createElement(n);
  e.async = true;
  e.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = b.getElementsByTagName(n)[0];
  s?.parentNode?.insertBefore(e, s);
  window.fbq('init', PIXEL_ID);
  window.fbq('init', '1280159590182564');
}
function PixelTracker() {
  const location = useLocation();
  const path = location.pathname;
  useEffect(() => {
    initFacebookPixel();
    // PageView on every page
    window.fbq('track', 'PageView');
    // ViewContent on every page
    window.fbq('track', 'ViewContent', {
      content_name: `AI Web Closer - ${path || '/'}`
    });
    // AddToCart on checkout page
    if (path === '/checkout') {
      window.fbq('track', 'AddToCart', {
        content_name: 'AI Web Closer Course',
        content_type: 'product',
        value: 27,
        currency: 'USD'
      });
    }
  }, [path]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <PixelTracker data-id="element-1" />
      <Suspense fallback={<div className="min-h-screen bg-navy flex items-center justify-center" data-id="element-3">
            <div className="w-8 h-8 border-2 border-gold border-t-transparent rounded-full animate-spin" data-id="element-4" />
          </div>} data-id="element-2">
        <Routes data-id="element-5">
          <Route path="/" element={<LandingPage data-id="element-7" />} data-id="element-6" />
          <Route path="/lp1" element={<LandingPageLP1 data-id="element-9" />} data-id="element-8" />
          <Route path="/lp2" element={<LandingPageV2 data-id="element-11" />} data-id="element-10" />
          <Route path="/lp3" element={<LandingPageLP3 data-id="element-13" />} data-id="element-12" />
          <Route path="/lp4" element={<LandingPageLP4 data-id="element-15" />} data-id="element-14" />
          <Route path="/lp5" element={<LandingPageLP5 data-id="element-17" />} data-id="element-16" />
          <Route path="/checkout" element={<CheckoutPage data-id="element-19" />} data-id="element-18" />
          <Route path="/checkout-2" element={<CheckoutPage2 data-id="element-21" />} data-id="element-20" />
          <Route path="/calculadora" element={<CalculadoraPage data-id="element-23" />} data-id="element-22" />
          <Route path="/member-signup" element={<SignupPage data-id="element-25" />} data-id="element-24" />
          <Route path="/login" element={<LoginPage data-id="element-27" />} data-id="element-26" />
          <Route path="/forgot-password" element={<ForgotPasswordPage data-id="element-29" />} data-id="element-28" />
          <Route path="/modulo-0" element={<Modulo0Page data-id="element-31" />} data-id="element-30" />
          <Route path="/modulo-1" element={<AccessPage data-id="element-33" />} data-id="element-32" />
          <Route path="/modulo-2" element={<Modulo2Page data-id="element-35" />} data-id="element-34" />
          <Route path="/modulo-3" element={<Modulo3Page data-id="element-37" />} data-id="element-36" />
          <Route path="/modulo-4" element={<Modulo4Page data-id="element-39" />} data-id="element-38" />
        </Routes>
      </Suspense>
    </BrowserRouter>;
}